import { Box } from '@chakra-ui/react';

import { TextRegular } from 'UiKit/typography';
import { CheckCircleIcon, ForkSpoonIcon, HandShakeIcon, PrayIcon, ToiletIcon } from 'Asset/icon';

import styles from './styles.module.css';

const BadgeOperatorStatus = ({ status }) => {
  let bgColor;
  let color;
  let icon;
  let textStatus = '';
  switch (status) {
    case 'BANTU_REKAN':
      bgColor = '#E7F1FF';
      color = 'var(--color-primary70)';
      icon = <HandShakeIcon size="10px" color="var(--color-primary70)" />;
      textStatus = 'Bantu Rekan';
      break;
    case 'ISTIRAHAT_MAKAN':
      bgColor = '#F1F1F1';
      color = 'var(--color-semantic-text)';
      icon = <ForkSpoonIcon size="10px" color="var(--color-semantic-text)" />;
      textStatus = 'Istirahat Makan';
      break;
    case 'SHOLAT':
      bgColor = '#F1F1F1';
      color = 'var(--color-semantic-text)';
      icon = <PrayIcon size="10px" color="var(--color-semantic-text)" />;
      textStatus = 'Istirahat Sholat';
      break;
    case 'TOILET':
      bgColor = '#F1F1F1';
      color = 'var(--color-semantic-text)';
      icon = <ToiletIcon size="10px" color="var(--color-semantic-text)" />;
      textStatus = 'Istirahat Toilet';
      break;
    case 'AVAILABLE':
      bgColor = '#E9FFF2';
      color = 'var(--color-success60)';
      icon = <CheckCircleIcon size="10px" color="var(--color-success60)" />;
      textStatus = 'Available';
      break;
    default:
      bgColor = '#F1F1F1';
      color = 'var(--color-semantic-text)';
      icon = null;
      textStatus = '-';
      break;
  }

  return (
    <Box bg={bgColor} className={styles['badge-operator__container']}>
      {icon}
      <TextRegular color={color} className={styles['badge-operator__text']}>
        {textStatus}
      </TextRegular>
    </Box>
  );
};

export default BadgeOperatorStatus;
